import { useGridApiRef } from '@mui/x-data-grid-pro';

import { RuleDomainType } from '~/common/types';
import { DataGridQueryBuilder, useDataGridQueryBuilderQuery } from '~/components/DataGridQueryBuilder';
import { DataGridWidget } from '~/components/DataGridWidget';
import { Filters, FilterSaveStatus, useFilters } from '~/components/Filters';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { RouteId } from '~/routes';
import { useRuleDataGridConfig } from '~/routes/RuleListSourcing/RuleListSourcing.dataGrid';
import { useRuleListSourcingDataGridQueryBuilderConfig } from '~/routes/RuleListSourcing/RuleListSourcing.queryBuilder.tsx';
import { RuleListDataGridField } from '~/routes/RuleListSourcing/RuleListSourcingDataGrid.types.ts';

import { RuleListPageHeader } from './components/RuleListPageHeader/RuleListPageHeader';
import { RULE_LIST_QUERY } from './RuleListSourcingQuery.gql';

const domain = RuleDomainType.RULE_SOURCING;

export const RuleListSourcing = () => {
  const { queryId, onQueryChange, onQueryIdChange, query, rulesTotal, loading } = useDataGridQueryBuilderQuery({
    domain,
  });
  const { onFilterSave, saveStatus, selected, ...filtersProps } = useFilters({ domain, queryId });
  const apiRef = useGridApiRef();

  return (
    <PageLayout
      fullHeight
      renderHeader={
        <>
          <RuleListPageHeader domain={domain}>
            <Filters
              {...filtersProps}
              selected={selected}
              onFilterSelect={(filter) => {
                onQueryIdChange(filter.queryId);
              }}
            />
          </RuleListPageHeader>
          <DataGridQueryBuilder
            query={query}
            clearDisabled={rulesTotal === 0}
            saveDisabled={saveStatus === FilterSaveStatus.DISABLED}
            onQueryChange={onQueryChange}
            onSave={onFilterSave}
            selectedFilterName={selected?.name}
            useConfig={useRuleListSourcingDataGridQueryBuilderConfig}
          />
        </>
      }
    >
      <DataGridWidget
        apiRef={apiRef}
        domain={domain}
        loading={loading}
        filter={query}
        filterCount={rulesTotal}
        useConfig={useRuleDataGridConfig}
        initialNavigateDetail={({ row }) => ({ to: RouteId.ruleDetail(row.id) })}
        pinnedColumns={{
          right: [RuleListDataGridField.ACTIONS],
        }}
        loadingProps={{
          query: RULE_LIST_QUERY,
          getNodes: (data) => data.tesseract.rules.sourcing.nodes,
          getTotalCount: (data) => data.tesseract.rules.sourcing.totalCount || 0,
        }}
      />
    </PageLayout>
  );
};
